import React, { useState, useEffect } from 'react';
import PlatformSelector from './PlatformSelector';
import Camel from './Camel';
import Starlink from './Starlink';
import Shadow from './Shadow';

interface PlatformManagerProps {
  initialUnitId?: string;
  onClearHexValue?: () => void;
  selectedPlatform?: 'camel' | 'starlink' | 'shadow';
}

const PlatformManager: React.FC<PlatformManagerProps> = ({ initialUnitId, onClearHexValue, selectedPlatform }) => {
  const [currentPlatform, setCurrentPlatform] = useState<'camel' | 'starlink' | 'shadow'>(selectedPlatform || 'camel');

  // Update platform when selectedPlatform prop changes
  useEffect(() => {
    if (selectedPlatform) {
      setCurrentPlatform(selectedPlatform);
    }
  }, [selectedPlatform]);

  // Clear hex value when component unmounts or platform changes
  useEffect(() => {
    return () => {
      if (onClearHexValue) {
        onClearHexValue();
      }
    };
  }, [currentPlatform]);

  return (
    <div style={{ padding: '20px' }}>
      <PlatformSelector 
        currentPlatform={currentPlatform}
        onPlatformChange={setCurrentPlatform}
      />
      
      {currentPlatform === 'camel' ? <Camel initialUnitId={initialUnitId} /> : 
       currentPlatform === 'starlink' ? <Starlink initialUnitId={initialUnitId} /> :
       <Shadow initialUnitId={initialUnitId} />}
    </div>
  );
};

export default PlatformManager;
